module.exports = __webpack_public_path__ + "img/cosleep_guidance_img_subscribe-wechat3_cn@3x.2646a842.png";